/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function LockFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="lock-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.75 11C2.783 10.294 3.099 9.512 3.555 9.055C4.012 8.599 4.794 8.283 5.5 8.25L18.5 8.25C19.206 8.283 19.988 8.599 20.445 9.055C20.901 9.512 21.217 10.294 21.25 11L21.25 18.5C21.217 19.206 20.901 19.988 20.445 20.445C19.988 20.901 19.206 21.217 18.5 21.25L5.5 21.25C4.794 21.217 4.012 20.901 3.555 20.445C3.099 19.988 2.783 19.206 2.75 18.5L2.75 11ZM12 13.75C11.448 13.75 11 14.198 11 14.75C11 15.302 11.448 15.75 12 15.75C12.552 15.75 13 15.302 13 14.75C13 14.198 12.552 13.75 12 13.75Z" data-tinysvg-shape="compound-path" fillRule="evenodd" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M8 9L8 7.5C8 5.291 9.791 3.5 12 3.5C14.209 3.5 16 5.291 16 7.5L16 9" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
